export default __webpack_public_path__ + "static/media/029-ice cream truck.ebd7c908.svg";